import React, { useState } from "react";
import tataMotorsLogo from "../../assets/images/tatamotorsLogo.svg";
import customerLogo from "../../assets/images/customer360_logo.png";
import sparqPlugLogo from "../../assets/images/sparqPlugLogo.svg";
import chartLogo from "../../assets/images/chartLogo.svg";
import customerManLogo from "../../assets/images/CustomerManLogo.svg";
import { newLogin } from "./loginKpi";
import { useNavigate } from "react-router-dom";
const NewLogin = () => {
  const [email, setEmail] = useState("p0001444.ttl@tatamotors.com");
  const [userName, setUserName] = useState("p0001444.ttl");
  const _id = "1";
  const navigate = useNavigate();
  // const [token, setToken] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { token, username } = await newLogin(_id, email, userName);
    if (token) {
      localStorage.setItem("token", token);
      localStorage.setItem("username", username);
      navigate("/home");
    }
  };

  return (
    <div className="flex">
      <div className=" hidden login-bg lg:block relative lg:w-[70%]">
        <div className="flex fixed top-0 left-0" style={{}}>
          <img
            className="h-[400px] w-[400px]"
            src={chartLogo}
            alt="chart logo"
          />
          <img
            className="h-[400px] w-[300px] translate-y-20"
            src={customerManLogo}
            alt="chart logo"
          />
        </div>
      </div>
      <div className="flex-1 p-4">
        <div className="w-full flex  flex-col items-center justify-center">
          <div className="w-full flex justify-between items-center">
            <img src={tataMotorsLogo} alt="" />
            <img src={sparqPlugLogo} alt="" />
          </div>
          <img
            src={customerLogo}
            alt="Customer Logo"
            className="h-[200px] w-[200px]"
          />
        </div>
        <div className="w-full flex flex-col items-center justify-center gap-4">
          <p className="w-full text-center text-2xl font-semibold">Login</p>
          <form
            onSubmit={handleSubmit}
            className="w-full flex flex-col items-center justify-center"
          >
            <div className="w-full">
              <p className="text-sm">E-Mail</p>
              <input
                className="bg-gray-100 p-2 rounded-md w-full"
                type="text"
                name=""
                id=""
                value={email}
              />
            </div>
            <div className="w-full">
              <p className="text-sm">Username</p>
              <input
                className="bg-gray-100 p-2 rounded-md w-full"
                type="text"
                name=""
                id=""
                value={userName}
              />
            </div>
            <div className="w-full">
              <p className="text-sm">Password</p>
              <input
                className="bg-gray-100 p-2 rounded-md w-full"
                type="password"
                name=""
                id=""
              />
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#1A467C] to-[#307FE2] p-2 rounded-md mt-8 text-white font-medium"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewLogin;
